export const ALERT_TYPE_LABELS = {
  vital: 'Vital Alert',
  vital_warning: 'Vital Warning',
  task: 'Task',
  nad_due: 'Appointment Due',
  rpm_dur_red: 'RPM Duration Red',
  ccm_dur_red: 'CCM Duration Red',
  rpm_dur_yellow: 'RPM Duration Yellow',
  ccm_dur_yellow: 'CCM Duration Yellow',
  no_recent_vitals: 'No Recent Vitals',
  no_monthly_vitals: 'No Monthly Vitals',
  pdd: 'PDD',
  cpt_completion: 'CPT Completion',
  npr30: 'NPR',
  care_plan_rpm_icd: 'RPM CarePlan Missing ICD Code',
  care_plan_ccm_icd: 'CCM CarePlan Missing ICD Code',
};

export const ALERT_TYPE_COLORS = {
  vital: 'red',
  vital_warning: 'yellow',
  task: 'green',
  nad_due: 'green',
  rpm_dur_red: 'blue',
  ccm_dur_red: 'blue',
  rpm_dur_yellow: 'light-blue',
  ccm_dur_yellow: 'light-blue',
  no_recent_vitals: 'orange',
  no_monthly_vitals: 'pink',
  pdd: 'gray',
  cpt_completion: 'purple',
  npr30: '#ffb38a',
  care_plan_rpm_icd: 'teal',
  care_plan_ccm_icd: 'teal',
};

export const ALERT_TYPE_DESCRIPTIONS = {
  vital: 'Resolve all vital alerts to clear this alert',
  vital_warning: 'Resolve all vital warnings to clear this alert',
  task: 'Close all open tasks/notes to clear this alert',
  nad_due: 'It has been over a week since last appointment, update next appointment date',
  rpm_dur_red: 'Complete RPM notes with durations to clear this alert',
  ccm_dur_red: 'Complete CCM notes with durations to clear this alert',
  rpm_dur_yellow: 'Complete RPM notes with durations to clear this alert',
  ccm_dur_yellow: 'Complete CCM notes with durations to clear this alert',
  no_recent_vitals: 'No recent reading (within 5 days)',
  no_monthly_vitals: 'No monthly reading (within 30 days)',
  pdd: 'Patient with no active RPM Care Plans has active Devices. Remove Tenovi devices to clear this alert',
  cpt_completion: 'Complete additional time for user to clear this alert',
  npr30: 'No patient response in 30 days',
  care_plan_rpm_icd: 'RPM Care Plan is missing ICD codes. Add ICD codes to the RPM Care Plan to clear this alert',
  care_plan_ccm_icd: 'CCM Care Plan is missing ICD codes. Add ICD codes to the CCM Care Plan to clear this alert',
};

// Ordered list of all alert type keys (priority order for display)
export const ALERT_TYPE_KEYS = [
  'vital',
  'vital_warning',
  'task',
  'nad_due',
  'rpm_dur_red',
  'ccm_dur_red',
  'no_recent_vitals',
  'no_monthly_vitals',
  'rpm_dur_yellow',
  'ccm_dur_yellow',
  'cpt_completion',
  'npr30',
  'pdd',
  'care_plan_rpm_icd',
  'care_plan_ccm_icd',
];

// White text is needed on these darker/colored backgrounds
export const ALERT_TYPE_WHITE_TEXT = ['blue', 'light-blue', 'pink', 'orange', 'purple', 'teal'];

const AlertTypesMixin = {
  methods: {
    alertLabel(type) {
      return ALERT_TYPE_LABELS[type] || type.replace(/_/g, ' ');
    },
    alertColor(type) {
      return ALERT_TYPE_COLORS[type] || 'blue';
    },
    alertDescription(type) {
      return ALERT_TYPE_DESCRIPTIONS[type] || '';
    },
    alertChipTextClass(color) {
      return ALERT_TYPE_WHITE_TEXT.includes(color) ? 'white--text' : '';
    },
    alertLevel(alerts) {
      if (alerts.vital) return 'red';
      if (alerts.vital_warning) return 'yellow';
      if (alerts.pdd) return 'gray';
      if (alerts.npr30) return '#ffb38a';
      if (alerts.cpt_completion) return 'purple';
      if (alerts.task) return 'green';
      if (alerts.nad_due) return 'green';
      if (alerts.rpm_dur_red || alerts.ccm_dur_red) return 'dodgerblue';
      if (alerts.no_monthly_vitals) return 'pink';
      if (alerts.no_recent_vitals) return 'orange';
      if (alerts.rpm_dur_yellow || alerts.ccm_dur_yellow) return 'cornflowerblue';
      if (alerts.care_plan_rpm_icd || alerts.care_plan_ccm_icd) return 'teal';
      return '';
    },
    alertOrder(alerts) {
      if (alerts.vital) return 100;
      if (alerts.vital_warning) return 90;
      if (alerts.pdd) return 86;
      if (alerts.npr30) return 85;
      if (alerts.cpt_completion) return 83;
      if (alerts.task) return 80;
      if (alerts.nad_due) return 75;
      if (alerts.rpm_dur_red || alerts.ccm_dur_red) return 70;
      if (alerts.no_monthly_vitals) return 66;
      if (alerts.no_recent_vitals) return 65;
      if (alerts.rpm_dur_yellow || alerts.ccm_dur_yellow) return 60;
      if (alerts.care_plan_rpm_icd || alerts.care_plan_ccm_icd) return 50;
      return 0;
    },
    alertName(type) {
      const names = {
        pdd: 'PDD',
        rpm_dur_red: 'task duration',
        ccm_dur_red: 'task duration',
        rpm_dur_yellow: 'task duration',
        ccm_dur_yellow: 'task duration',
        vital: 'vital',
        vital_warning: 'vital',
        task: 'task',
        no_recent_vitals: 'NRR',
        no_monthly_vitals: 'NMR',
        nad_due: 'appt-due',
        cpt_completion: 'CPT completion',
        npr30: 'NPR',
        care_plan_rpm_icd: 'RPM ICD',
        care_plan_ccm_icd: 'CCM ICD',
      };
      return names[type] || type;
    },
    // kept for backwards-compat with rpm/Alerts.vue template
    alertDescriptions(type) {
      return this.alertDescription(type);
    },
  },
};

export default AlertTypesMixin;

